import styled from 'styled-components';

import LoadingWrapper from '../../../../../CoreWrappers/LoadingWrapper';

export default styled(LoadingWrapper)`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	max-height: var(--max-height);
	padding: var(--gap);
	gap: var(--gap);
	.controls {
		display: flex;
		gap: var(--spacing-small);
	}
	.manage-access {
		padding: 0rem;
	}
`;
